import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  margin: 0 auto;
`;

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.5rem;

  & > button {
    padding-bottom: 1.25rem;
  }

  & > span {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark2};
  }
  margin-bottom: 0.5rem;
`;

export const DashboardItemContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};
`;
